var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faSearch } from "@fortawesome/pro-regular-svg-icons";
import { faList } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
var PopupDefsHome = function (_a) {
    var layoutKey = _a.layoutKey;
    return (_jsx("div", __assign({ className: "px-6 py-2 " }, { children: _jsxs("div", __assign({ className: "flex flex-col gap-2 border-l-4 p-1 border-gray-200" }, { children: [_jsxs(Link, __assign({ to: "".concat(layoutKey, "/popuplist"), className: "flex items-center p-1 text-sm  hover:bg-gray-100" }, { children: [_jsx(FontAwesomeIcon, { icon: faList, className: "mr-2" }), "Popup List"] })), _jsxs(Link, __assign({ to: "".concat(layoutKey, "/popupsearchdefs"), className: "flex items-center p-1 text-sm  hover:bg-gray-100" }, { children: [_jsx(FontAwesomeIcon, { icon: faSearch, className: "mr-2" }), "Popup Search"] }))] })) })));
};
export default PopupDefsHome;
